/**
 * Built-in presenter characters.
 *
 * Each character ships four hand-authored poses. They are pre-made rather than
 * AI-generated per session because a generated character will not stay visually
 * consistent across four separate poses — the whole illusion depends on only
 * the arm changing between cuts.
 *
 * Assets are SVG so they stay small and editable in the repo. Each file carries
 * explicit width/height, which is what lets the canvas draw them directly — an
 * SVG with no intrinsic size renders at a browser default instead.
 */
import type { PoseKind } from "./types";

export interface CharacterDefinition {
	id: string;
	name: string;
	/** Source SVG per pose, served from /public. */
	poses: Record<PoseKind, string>;
}

export const CHARACTERS: CharacterDefinition[] = [
	{
		id: "presenter",
		name: "Presenter",
		poses: {
			this: "/characters/presenter/this.svg",
			that: "/characters/presenter/that.svg",
			idle: "/characters/presenter/idle.svg",
			thinking: "/characters/presenter/thinking.svg",
		},
	},
	{
		id: "robot",
		name: "Robot",
		poses: {
			this: "/characters/robot/this.svg",
			that: "/characters/robot/that.svg",
			idle: "/characters/robot/idle.svg",
			thinking: "/characters/robot/thinking.svg",
		},
	},
	{
		id: "hero",
		name: "Hero",
		poses: {
			this: "/characters/hero/this.svg",
			that: "/characters/hero/that.svg",
			idle: "/characters/hero/idle.svg",
			thinking: "/characters/hero/thinking.svg",
		},
	},
	{
		id: "cat",
		name: "Cat",
		poses: {
			this: "/characters/cat/this.svg",
			that: "/characters/cat/that.svg",
			idle: "/characters/cat/idle.svg",
			thinking: "/characters/cat/thinking.svg",
		},
	},
	{
		id: "wizard",
		name: "Wizard",
		poses: {
			this: "/characters/wizard/this.svg",
			that: "/characters/wizard/that.svg",
			idle: "/characters/wizard/idle.svg",
			thinking: "/characters/wizard/thinking.svg",
		},
	},
];

export const DEFAULT_CHARACTER_ID = "presenter";

export function getCharacter({ id }: { id: string }): CharacterDefinition {
	return CHARACTERS.find((character) => character.id === id) ?? CHARACTERS[0];
}
